import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerformanceTableComponent } from './performance-table.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatPaginatorModule } from '@angular/material/paginator';



@NgModule({
  declarations: [
    PerformanceTableComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatPaginatorModule
  ],
  exports:[
    PerformanceTableComponent
  ]
})
export class PerformanceTableModule { }
